import { Filter, ChevronsRight } from 'lucide-react';
import type { TabId, TabState } from '../types';
import { SUB_REGIONS } from '../utils/regions';
import { ALL_DATA } from '../data/deals';
interface Props {
  tab: TabId;
  state: TabState & {
    status?: string;
  };
  onUpdate: (updates: Partial<TabState>) => void;
}
function getFYOptions(): string[] {
  const fySet = new Set(ALL_DATA.map(d => d.created_fy).filter(Boolean));
  return ['All', ...Array.from(fySet).sort()];
}
function getLabel(tab: TabId, s: TabState & {
  status?: string;
}): string {
  let lbl = s.r;
  if (s.sub && s.sub !== 'All') lbl += ' › ' + s.sub;
  if (tab === 'vp' && s.status) lbl += ' · ' + s.status;
  const fyPart = s.fy !== 'All' ? s.fy : '';
  const qPart = s.q !== 'All' ? s.q : '';
  if (fyPart || qPart) lbl += ' · ' + (fyPart && qPart ? fyPart + '-' + qPart : fyPart || qPart);
  return lbl;
}
export function FilterBar({
  tab,
  state,
  onUpdate
}: Props) {
  const fyOptions = getFYOptions();
  const quarters = ['All', 'Q1', 'Q2', 'Q3', 'Q4'];
  const statuses = ['All', 'In Progress', 'Closed', 'On Hold'];
  const regions = ['Global', 'AMER', 'EMEA', 'JAPAC'];
  const subRegions = SUB_REGIONS[state.r] ?? [];
  function setRegion(r: string) {
    onUpdate({
      r,
      sub: 'All'
    });
  }
  return <div className="bg-white px-[18px] py-[10px] flex gap-4 flex-wrap items-start border-b border-[#e8eaf0] shadow-[0_1px_3px_rgba(0,0,0,0.04)]" data-id="element-46">
      {/* Region */}
      <div className="flex flex-col gap-[6px]" data-id="element-47">
        <div className="text-[9px] font-bold text-[#8892a0] uppercase tracking-[.06em]" data-id="element-48">Region</div>
        <div className="flex gap-1 flex-wrap" data-id="element-49">
          {regions.map(r => <button key={r} className={`rpill ${state.r === r ? 'active' : ''}`} onClick={() => setRegion(r)} data-id="element-50">
              {r}
            </button>)}
        </div>
        {subRegions.length > 0 && <div className="flex items-center gap-[6px] pt-1 flex-wrap" data-id="element-51">
            <span className="text-[9px] font-semibold text-[#8892a0] uppercase tracking-[.05em] whitespace-nowrap flex items-center gap-1" data-id="element-52">
              <ChevronsRight className="w-[10px] h-[10px] text-[#d0d5dd]" data-id="element-53" />Sub-region
            </span>
            <div className="flex gap-1 flex-wrap" data-id="element-54">
              <button className={`srpill ${state.sub === 'All' ? 'active' : ''}`} onClick={() => onUpdate({
            sub: 'All'
          })} data-id="element-55">
                All {state.r}
              </button>
              {subRegions.map(s => <button key={s} className={`srpill ${state.sub === s ? 'active' : ''}`} onClick={() => onUpdate({
            sub: s
          })} data-id="element-56">
                  {s}
                </button>)}
            </div>
          </div>}
      </div>

      {/* Status (VP only) */}
      {tab === 'vp' && <div className="flex flex-col gap-[6px]" data-id="element-57">
          <div className="text-[9px] font-bold text-[#8892a0] uppercase tracking-[.06em]" data-id="element-58">Status</div>
          <div className="flex gap-1 flex-wrap" data-id="element-59">
            {statuses.map(s => <button key={s} className={`rpill ${(state.status ?? 'All') === s ? 'active' : ''}`} onClick={() => onUpdate({
          status: s
        })} data-id="element-60">
                {s}
              </button>)}
          </div>
        </div>}

      {/* Created Quarter */}
      <div className="flex flex-col gap-[6px]" data-id="element-61">
        <div className="text-[9px] font-bold text-[#8892a0] uppercase tracking-[.06em]" data-id="element-62">Created Quarter</div>
        <div className="flex items-center gap-2 flex-wrap" data-id="element-63">
          <select className="fy-select" value={state.fy} onChange={e => onUpdate({
          fy: e.target.value
        })} data-id="element-64">
            {fyOptions.map(y => <option key={y} value={y} data-id="element-65">{y === 'All' ? 'All FY' : 'FY' + y}</option>)}
          </select>
          <div className="w-px h-[18px] bg-[#e8eaf0] flex-shrink-0" data-id="element-66" />
          {quarters.map(q => <button key={q} className={`cqfpill ${state.q === q ? 'active' : ''}`} onClick={() => onUpdate({
          q
        })} data-id="element-67">
              {q === 'All' ? 'All Q' : q}
            </button>)}
        </div>
      </div>

      {/* Summary label */}
      <div className="text-[10px] text-[#8892a0] ml-auto self-center flex items-center gap-1" data-id="element-68">
        <Filter className="w-[11px] h-[11px]" data-id="element-69" />
        {getLabel(tab, state)}
      </div>
    </div>;
}